module.exports = require("isomorphic-vm");


//////////////////
// WEBPACK FOOTER
// external "isomorphic-vm"
// module id = 36
// module chunks = 0